<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html {
  overflow-x: hidden;
}
/* Scroll */
::-webkit-scrollbar {
  width: 5px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
  background: #D7D7D7;
}
::-webkit-scrollbar-thumb:hover {
  background: #C6C6C6;
}
#app {
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
h1, h2, h3, h4 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  text-decoration: none !important;
}
a:hover {
  text-decoration: none !important;
}
p {
  text-align: left;
}
button:disabled {
  opacity: 0.3;
}
.clearfix {
  margin: 15px 15px 15px 15px;
}
.clearfix--min {
  margin: 5px 5px 5px 5px;
}
.clearfix--max {
  margin: 25px 25px 25px 25px;
}
.container {
  margin-bottom: 20px;
  margin-top: 23vh !important;
  min-height: 100vh; /* will cover the 100% of viewport */
}
[v-cloak] {
  display: none;
}
summary {
  outline: none;
}
details > summary {
  list-style: none;
}
details > summary::marker,
details > summary::-webkit-details-marker {
  display: none;
}
.img-logo-xl {
  width: 18vw;
}
@media screen and (-webkit-min-device-pixel-ratio:0) {
  select,
  textarea,
  input {
    font-size: 16px;
  }
}
/* Portrait */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  h1, h2 {
    font-size: 1.5em;
  }
  small {
    font-size: .6em !important;
  }
  .small-right {
    margin: .5em !important;
  }
  .container--mobile {
    margin-top: 11vh !important;
  }
  .list-group-item {
    font-size: .7em;
  }
  .img-logo-xl {
    width: 55vw;
  }
  .header-wrapper {
    display: block !important;
  }
}
.previous-answer::after {
  content: '\2713';
  float: right;
  margin-left: -10px;
}
.div-loader {
  display: none;
}
.div-loader:after {
  content: " ...";
  animation: dots 1s steps(5, end) infinite;
}
@keyframes dots {
  0%,
  20% {
    color: rgba(0, 0, 0, 0);
    text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  40% {
    color: white;
    text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  60% {
    text-shadow: 0.25em 0 0 white, 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  80%,
  100% {
    text-shadow: 0.25em 0 0 white, 0.5em 0 0 white;
  }
}
.pulse {
  box-shadow: 0 0 0 0 rgba(187, 187, 187, 0.7);
  -webkit-animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  -moz-animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  -ms-animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  transition: all 300ms ease-in-out;
}
@-webkit-keyframes pulsing {
  to {
    box-shadow: 0 0 0 15px rgba(232, 76, 61, 0);
  }
}
@-moz-keyframes pulsing {
  to {
    box-shadow: 0 0 0 15px rgba(232, 76, 61, 0);
  }
}
@-ms-keyframes pulsing {
  to {
    box-shadow: 0 0 0 15px rgba(232, 76, 61, 0);
  }
}
@keyframes pulsing {
  to {
    box-shadow: 0 0 0 15px rgba(232, 76, 61, 0);
  }
}
/* bootstrap override */
.alert-bottom-right {
  position: fixed;
  bottom: 12vh;
  right: 0;
  height: auto;
  width: auto;
  margin: 2rem;
}
.btn-primary {
  background: #069ccc !important;
  border-color: #069ccc !important;
}
.btn-outline-secondary {
  border-color: #069ccc !important;
  border-width: 2px;
}
.btn-outline-secondary:not(:disabled):not(.disabled):hover {
  color: #fff !important;
  background: #069ccc !important;
}
.btn-outline-secondary:not(:disabled):not(.disabled).active,
.btn-outline-secondary:not(:disabled):not(.disabled):active {
  background: #069ccc !important;
}
.text-primary-fh {
  color: #069ccc !important;
}
.navbar-toggler {
  border-color: transparent !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue